import type { Patient } from "./calculateBasicInfoCompletion";
import type { BasicInfoState } from "./types";

type PatientMedicalHistory = NonNullable<Patient["medicalHistory"]>;
type PatientMedicationHistory = NonNullable<
  PatientMedicalHistory["medications"]
>[number];

type BasicInfoMedicationHistory =
  | (Pick<PatientMedicalHistory, "currentlyTakingMedications"> & {
      medications?:
        | readonly Pick<
            PatientMedicationHistory,
            "id" | "name" | "brand" | "frequency" | "notes"
          >[]
        | null;
    })
  | null
  | undefined;

export function getBasicInfoMedicationState(
  previousState: Pick<
    BasicInfoState,
    "currentlyTakingMedications" | "medications"
  >,
  medicalHistory: BasicInfoMedicationHistory,
): Pick<BasicInfoState, "currentlyTakingMedications" | "medications"> {
  const medications = Array.isArray(medicalHistory?.medications)
    ? medicalHistory.medications
        .filter((medication) => medication.name)
        .map((medication) => ({
          id: medication.id,
          name: medication.name!,
          brand: medication.brand ?? null,
          frequency: medication.frequency ?? null,
          notes: medication.notes ?? null,
        }))
    : [];

  return {
    ...previousState,
    currentlyTakingMedications:
      medicalHistory?.currentlyTakingMedications ?? null,
    medications,
  };
}
